export default __webpack_public_path__ + "static/media/ding.d283d9d3.mp3";